module.exports = __webpack_public_path__ + "img/icon_03.cbcda11.png";